<script>
import { Line } from "vue-chartjs";
export default {
  extends: Line,
  props: {
    chartdata: {
      type: Array,
      default: null,
    },
  },
  watch: {
    chartdata: "render",
  },
  methods: {
    render() {
      var length = this.chartdata.length;
      var array = this.chartdata;
      // Create new arrays to store the data
      var uniquesArray = [];
      var countArray = [];
      var timeStampArray = [];

      for (var i = 0; i < length; i++) {
        // Then push our data to the new arrays
        uniquesArray.push(array[i] ? array[i]["unique"] : "");
        countArray.push(array[i] ? array[i].count : "");
        timeStampArray.push(
          array[i] ? this.frontEndDate(array[i].timestamps) : ""
        );
      }
      this.renderChart(
        {
          labels: timeStampArray,
          datasets: [
            {
              label: "Uniques",
              borderColor: "#6AB2F5",
              fill: false,
              lineTension: 0,
              data: uniquesArray,
            },
            {
              label: "Count",
              borderColor: "#f56a6a",
              fill: false,
              lineTension: 0,
              data: countArray,
            },
          ],
          steppedLine: true,
        },
        {
          responsive: true,
        }
      );
    },
    frontEndDate(date) {
      date = date.toString();
      date = date.split("T")[0];

      return date;
    },
  },
  mounted() {
    this.render();
  },
};
</script>
